import type { PublishedTeam } from '@tempo-io/roadmap-dto';
import type { Team } from '@/common/api/types/teams';
import { useGetTeamsQuery } from '@/features/teams/queries/useGetTeamsQuery';
import { teamsQueryKeys } from '@/features/teams/queryKeys';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/features/views/components/published/usePublishedSnapshotQuery';

function mapPublishedTeam(t: PublishedTeam): Team {
  return {
    id: t.id,
    name: t.name,
    color: t.color ?? '',
    totalCapacitySeconds: null,
    createdAt: '',
    updatedAt: '',
    createdBy: '',
    updatedBy: '',
    organizationId: '',
    description: null,
  };
}

export const useTeamsQueryWithPublished = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const teamsQuery = useGetTeamsQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: teamsQueryKeys.all(),
    getSnapshot: () => publishedContext?.teams.map(mapPublishedTeam),
  });

  if (isPublished) return publishedQuery;
  return { ...teamsQuery, data: teamsQuery.data?.data };
};
